import * as React from 'react';
var PanelContext = React.createContext({});
export default PanelContext;